import React from 'react'
import { FaArrowRight } from "react-icons/fa6";
import bookImg from "../../asstes/book.webp"
import chatImg from "../../asstes/chat.png"
const HeroSection = () => {
  return (
    <>
      <div className='w-full py-5'>
        <div className=' px-4    md:mx-auto  md:flex justify-around items-center  '>
          <div className='w-full  md:w-[48%] text-center py-4 gap-6 px-6 rounded-lg bg-[#333] hover:bg-[#444] cursor-pointer flex flex-col md:flex-row justify-between items-center mt-8 md:mt-0'>
            <div className=''>
              <h2 className='text-white text-3xl text-center md:text-start py-2'>Documentation</h2>
              <p className='text-gray-400 text-xl md:text-start'>Participant learning <br/> platform</p>
              <button className='mt-4 md:mt-20 mx-auto md:m-0 flex items-center gap-3 text-white font-bold justify-center'>Start learning <span className='mt-1'><FaArrowRight /></span> </button>
            </div>
            <img className='object-cover md:ml-12' src={bookImg} alt="chatImg" />
          </div>
          <div className='w-full text-center md:w-[48%] py-4 gap-6 px-6 rounded-lg bg-[#333] hover:bg-[#444] cursor-pointer flex flex-col md:flex-row justify-between items-center mt-8 md:mt-0'>
            <div className=''>
              <h2 className='text-white text-3xl text-center md:text-start py-2'>Live chat</h2>
              <p className='text-gray-400 text-xl md:text-start'>Platform where you can ask a question to experienced mentors</p>
              <button className='mt-4 md:mt-20 mx-auto md:m-0 flex items-center gap-3 text-white font-bold justify-center'> Find a mentor <span className='mt-1'><FaArrowRight /></span> </button>
            </div>
            <img className='object-cover md:ml-12' src={chatImg} alt="chatImg" />
          </div>
        </div>
      </div>
    </>
  )
}

export default HeroSection
